
import React from 'react';
import { TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';

interface CategoryTabsProps {
  categories: string[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
}

const CategoryTabs: React.FC<CategoryTabsProps> = ({ 
  categories, 
  activeTab, 
  setActiveTab 
}) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <>
      <TabsList className="grid w-full grid-cols-3 mb-4">
        {categories.slice(0, 3).map((category) => (
          <TabsTrigger 
            key={category} 
            value={category}
            className="capitalize"
          >
            {category}
          </TabsTrigger>
        ))}
      </TabsList>
      
      {categories.length > 3 && (
        <div className="px-4 pb-2 flex flex-wrap gap-2">
          {categories.slice(3).map((category) => (
            <Button
              key={category}
              variant={activeTab === category ? "default" : "outline"}
              size="sm"
              onClick={() => setActiveTab(category)}
              className="capitalize"
            >
              {category}
            </Button>
          ))}
        </div>
      )}
    </>
  );
};

export default CategoryTabs;
